import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Button, Modal } from './ui';

/**
 * Sign-out asks first. The button is a small icon beside everything else in
 * the header, and on a phone in a gloved hand it is easy to hit by accident —
 * after which the lab on this device is forgotten too.
 */
export default function SignOutDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { user, signOut } = useAuth();
  const [busy, setBusy] = useState(false);

  async function confirm() {
    setBusy(true);
    try {
      await signOut();
    } finally {
      setBusy(false);
      onClose();
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Sign out?">
      <p className="text-sm text-ink-300">
        You are signed in as{' '}
        <strong className="text-ink-100">{user?.email ?? user?.displayName ?? 'this account'}</strong>.
      </p>
      <p className="mt-2 text-sm text-ink-400">
        Nothing is deleted — your projects stay saved to your account. Sign in again with the
        same account to pick up where you left off.
      </p>
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button variant="danger" loading={busy} onClick={() => void confirm()}>
          Sign out
        </Button>
      </div>
    </Modal>
  );
}
